import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getOtherIssues } from 'services/glass-management/glassManagement';

export const fetchOtherIssues = createAsyncThunk('glass/other-issues/fetch', async (filters, { signal }) => {
    const res = await getOtherIssues(filters, signal);
    return { data: res };
});

export const otherIssuesSlice = createSlice({
    name: 'otherIssuesBit',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchOtherIssues.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOtherIssues.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchOtherIssues.rejected, (state, action) => {
                // Do nothing if aborted to continue loading
                if (action.meta.aborted)
                    return;

                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load other issues!';
                state.data = null;
            });
    }
});

export default otherIssuesSlice.reducer;
